/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyTypeModel } from '../../models/client-survey-type-model';

export interface GetSurveyTypes$Json$Params {
}

export function getSurveyTypes$Json(http: HttpClient, rootUrl: string, params?: GetSurveyTypes$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyTypeModel>>> {
  const rb = new RequestBuilder(rootUrl, getSurveyTypes$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientSurveyTypeModel>>;
    })
  );
}

getSurveyTypes$Json.PATH = '/api/SurveyType';
